const containerTheme = {
  baseStyle: {
    maxW: '1390px',
    w: '100%',
    px: '34px',
  },
};

export default containerTheme;
